import {
  SET_PGS_GAME_NAMES,
  SET_PGS_GAME_IMAGES,
  SET_PGS_GAME_POLA,
  SET_GAME_ISLOADING,
  SET_GAME_ISERROR
} from '../actionTypes';

const initialState = {
  pgsNames: [],
  pgsImages: [],
  pgsPolas: [],
  nameAndImagesIsLoading: true,
  isError: null
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PGS_GAME_NAMES:
      return { ...state, pgsNames: action.payload }
    case SET_PGS_GAME_IMAGES:
      return { ...state, pgsImages: action.payload };
    case SET_PGS_GAME_POLA:
      return { ...state, pgsPolas: action.payload };
    case SET_GAME_ISLOADING:
      return { ...state, nameAndImagesIsLoading: action.payload };
    case SET_GAME_ISERROR:
      return { ...state, isError: action.payload };
    default:
      return state;
  };
};

export default reducer;